import * as React from 'react';

interface IProps {
    className?: string;
}

class IconEllipseBottomRight extends React.Component<IProps> {
    public render() {
        return (
            <svg width="175" height="324" viewBox="0 0 175 324" fill="none" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
                <circle cx="162" cy="162" r="137" stroke="#039BE5" strokeWidth="50" />
            </svg>
        );
    }
}

export default IconEllipseBottomRight;
